export class BenefitLists {
  static VictimBenefitList = [
    {
      title: 'Counselling services or expenses',
      target: 'All victims of crime',
      examples: ['Counselling Sessions', 'Psycho-educational sessions to others who support the victim']
    },
    {
      title: 'Medical services or expenses',
      target: 'Victims who need health care because of their injuries from the crime',
      examples: [
        'Ambulance or emergency transportation',
        'Diagnosis and treatment by doctors or health professionals (e.g., physiotherapists, massage therapists)',
        'Health care services at a facility',
        'Medical equipment and supplies'
      ]
    },
    {
      title: 'Dental services or expenses',
      target: 'Victims who need dental care because of their injuries from the crime',
      examples: [
        'Diagnosis and treatment by a dentis or dental health professional',
        'Bridges, crowns, dengures, and other dental appliances or devices'
      ]
    },
    {
      title: 'Prescription drug expenses',
      target:
        'Victims who need prescription drugs to recover from, or manage the effects of, their injuries from the crime',
      examples: ['Medications prescribed by a doctor, dentist, or podiatrist']
    },
    {
      title: 'Protective measures, services, or expenses',
      target:
        'Victims who are at risk of additional harm from the perpetrator or are traumatized to the extent that they cannot perform regular daily activities',
      examples: [
        'Security or communication equipment and services',
        'Courses for personal protection or security',
        'Relocation expenses'
      ]
    },
    {
      title: 'Income support',
      target:
        'Victims whose injuries have a short-term or long-term effect on their ability to work and who had a job when the crime occurred (special eligibility issues for minors)',
      examples: ['Monthly payments to assist in financially supporting the victim']
    },
    {
      title: 'Lost earning capacity',
      target:
        'Victims whose injuries have a long-term effect on their ability to work and who did not have a job when the crime occurred (special eligibility issues for minors)',
      examples: ['Monthly payments to assist in financially supporting the victim']
    },
    {
      title: 'Vocational services or expenses',
      target:
        'Victims whose injuries prevent them from returning to their job and who need training or education to re-enter the workforce',
      examples: [
        'Education and training courses',
        'Programs to improve skills and qualifications',
        'Programs to prepare for, or find, employment'
      ]
    },
    {
      title: 'Transportation and related expenses, and transportation related childcare',
      target:
        'Victims who have to travel some distance to obtain medical, dental, counselling, or vocational services provided as crime victim assistance benefits',
      examples: [
        'Transportation expenses such as bus fare, air fare, or mileage expenses',
        'Meals and accomodation',
        'Childcare while attending appointments'
      ]
    },
    {
      title: 'Repair or replacement of damaged or destroyed personal property',
      target:
        'Victims whose eyeglasses/contacts, disability aids, or articles of clothing were damaged or destroyed because of the crime',
      examples: ['Eyeglass frames', 'Prescription lenses', 'Various types of disability aids', 'Clothing']
    },
    {
      title: 'Disability aids',
      target:
        'Victims who need disability aids because of their injuries from the crime, to reduce the effects of the injuries, improve their quality of life, and assist in daily living',
      examples: ['Mobility aids', 'Communication aids', 'Vision aids', 'Specialized clothing']
    },
    {
      title: 'Childcare services or expenses (see also under transportation)',
      target:
        'Victims who have a disability because of the crime that prevents them from providing care for their children (and no one else in the  household can perform the household tasks)',
      examples: ['Childcare']
    },
    {
      title: 'Homemaker services or expenses',
      target:
        'Victims who have a disability because of the crime that prevents them from doing household tasks (and no one else in the household can perform the household tasks)',
      examples: ['Help with shopping, clearning, cooking, and other household tasks']
    },
    {
      title: 'Personal care services or expenses',
      target:
        'Victims who have a disability because of the crime that prevents them from performing personal care tasks',
      examples: ['Help with bathing, dressing, toileting, and other personal care tasks']
    },
    {
      title: 'Home modification expenses',
      target:
        'Victims who have a disability because of the crime and need modifications made to their home to assist them in daily activities',
      examples: [
        'Structural changes such as replacing steps with a ramp, widening doorways, constructing custom showers, etc.',
        'Installed equipment such as wheelchair lifts, bath lifts or shower stalls, wing taps on sinks, etc.'
      ]
    },
    {
      title: 'Home maintenance expenses',
      target:
        'Victims who have a disability because of the that prevents them from maintaining their home (and no one else in the household can maintain the home)',
      examples: ['A monthly allowance for home maintenance expenses']
    },
    {
      title: 'Moving expenses',
      target: 'Victims who have long-term disability because of the crime and need to move to a more accessible home',
      examples: [
        'Moving expenses for the victim and family and their household goods',
        'Rental security deposit',
        'Connection fees for phone and utility'
      ]
    },
    {
      title: 'Vehicle modification or acquisition',
      target:
        'Victims who have a long-term disability because of the crime and need an accessible vehicle (to drive or be driven in) for greater independence',
      examples: [
        'Installed equipment such as hand controls or wheelchair lift',
        'Purchase or lease of an accessible vehicle'
      ]
    },
    {
      title: 'Maintenance for a child born as a result of a prescribed offence',
      target: 'Victims who conceived a child as a result of the crime and are financially supporting the child',
      examples: ['Monthly payments to assist in financially supporting the child']
    },
    {
      title: 'Crime scene cleaning',
      target:
        'Victims who were injured at their home or in their vehicle and need specialized cleaning of the home or vehicle due to the nature of the crime.',
      examples: [
        'Specialized cleaning and disinfecting of contaminated areas',
        'Replacement of contaminated flooring, wall covering, or other built-in features'
      ]
    }
  ];

  static IfmBenefitList = [
    {
      title: 'Counselling services or expenses',
      target:
        'Immediate Family Members who need counselling to recover from the psychological injury caused by the crime',
      examples: ['Counselling Sessions']
    },
    {
      title: 'Prescription drug expenses',
      target:
        'Immediate Family Members who need prescription drugs to recover from the psychological injury caused by the crime',
      examples: ['Medications prescribed by a doctor']
    },
    {
      title: 'Transportation and related expenses, and transportation related childcare',
      target:
        'Immediate Family Members who have to travel some distance to obtain counselling or vocational services provided as CVAP benefits. Immediate Family Members of deceased victims who have to travel over 100 km to attend legal proceedings regarding the death',
      examples: [
        'Transportation expenses such as bus fare, air fare, mileage expenses',
        'Meals and accommodation',
        'Childcare while attending appointments'
      ]
    },
    {
      title: 'Funeral Expenses',
      target: 'Immediate Family Members of deceased victims who have to pay for funeral and related costs',
      examples: ['Costs involved in the funeral service, burial, cremation or related ceremony']
    },
    {
      title: 'Bereavement leave',
      target:
        'Immediate Family Members of deceased victims who lose earnings from taking time off work for the funeral or other matters related to the victim’s death',
      examples: ['An amount to help offset the loss of earnings']
    },
    {
      title: 'Income support',
      target:
        'Spouses of deceased victims, Children of deceased victims, Other immeditate family members of deceased victims if they were financially dependent on the victim',
      examples: ['Monthly payments to assist in financially supporting the immediate family member']
    },
    {
      title: 'Loss of parental guidance for a minor child',
      target: 'Children of deceased victims who were under 19 when their parent was killed',
      examples: ['A set amount as a contribution toward loss of parental guidance']
    },
    {
      title: 'Vocational services or expenses',
      target:
        'Spouses of deceased victims who need training or education to prepare for employment or improve their earning capacity (and who are eligible for income support benefits from CVAP)',
      examples: [
        'Education and training courses',
        'Programs to improve skills and qualifications',
        'Programs to prepare for, or find, employment'
      ]
    },
    {
      title: 'Childcare services or expenses (see also under transportation)',
      target:
        'Spouses of deceased victims who need to pay for childcare because there is no one in the household to share this responsibility',
      examples: ['Childcare']
    },
    {
      title: 'Homemaker services or expenses',
      target:
        'Spouses of deceased victims who need to pay for homemaker services because there is no one in the household to  share household tasks',
      examples: ['Help with shopping, cleaning, cooking, and other household tasks']
    },
    {
      title: 'Crime scene cleaning',
      target:
        'Immediate Family Members who need specialized cleaning of the victim’s home or vehicle (if the victim is deceased), or their own home or vehicle, because the crime was committed there',
      examples: [
        'Specialized cleaning and disinfecting of contaminated areas',
        'Replacement of contaminated flooring, wall covering, or other built-in features'
      ]
    }
  ];

  static WitnessBenefitList = [
    {
      title: 'Counselling services or expenses',
      target: 'Witnesses who need counselling to recover from the psychological injury caused by witnessing the crime.',
      examples: ['Counselling Sessions']
    },
    {
      title: 'Prescription drug expenses',
      target:
        'Witnesses who need prescription drugs to recover from the psychological injury caused by witnessing the crime.',
      examples: ['Medications prescribed by a doctor']
    },
    {
      title: 'Transportation and related expenses, and transportation related childcare',
      target:
        'Witnesses who have to travel some distance to obtain counselling services provided as crime victim assistance benefits.',
      examples: [
        'Transportation expenses such as bus fare, air fare, mileage expenses',
        'Meals and accommodation',
        'Childcare while attending appointments'
      ]
    },
    {
      title: 'Crime scene cleaning',
      target: 'Witnesses who need specialized cleaning of their home or vehicle because the crime was committed there.',
      examples: [
        'Specialized cleaning and disinfecting of contaminated areas',
        'Replacement of contaminated flooring, wall covering, or other built-in features'
      ]
    }
  ];
}
